import { render } from "./CommonMessageWsHomeTop.vue?vue&type=template&id=874c3786&scoped=true"
import script from "./CommonMessageWsHomeTop.vue?vue&type=script&lang=js"
export * from "./CommonMessageWsHomeTop.vue?vue&type=script&lang=js"

import "./CommonMessageWsHomeTop.vue?vue&type=style&index=0&id=874c3786&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-874c3786"],['__file',"src/views/h5/common/home/components/top/CommonMessageWsHomeTop.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "874c3786"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('874c3786', __exports__)) {
    api.reload('874c3786', __exports__)
  }
  
  module.hot.accept("./CommonMessageWsHomeTop.vue?vue&type=template&id=874c3786&scoped=true", () => {
    api.rerender('874c3786', render)
  })

}


export default __exports__